<div class="container" *ngIf="page == 'console'">
  <app-layout-fixed-notifications
    *ngIf="model.accountSelected?.status === 'N' && !(model.user.isSales || model.user.isSupportMerchant)"
    [title]="'settings.company.notificationActivateAccount.title'" [status]="'attention'"
    [button]="'settings.company.notificationActivateAccount.button'" (clickNotification)="activateAccount()">
  </app-layout-fixed-notifications>
  <app-layout-fixed-notifications *ngIf="model.errorNotification"
    [title]="'settings.merchant.notificationPayoutProblem.title'" [status]="'error'"
    [button]="'settings.merchant.notificationPayoutProblem.button'" (clickNotification)="
      model.user.portal ? seeDetailsPayout() : seeDetailsPayoutPartner()
    ">
  </app-layout-fixed-notifications>
  @if (model.user.portal == 'merchant') {
    <app-layout-fixed-notifications *ngIf="model.errorPixType"
      [title]="'settings.merchant.notificationErrorPixType.title'" [status]="'attention'"
      [button]="'settings.merchant.notificationErrorPixType.button'"
      (clickNotification)="seeDetailsPayout()">
    </app-layout-fixed-notifications>
    <app-layout-fixed-notifications *ngIf="model.missingPixType"
      [title]="'settings.merchant.notificationMissingPixType.title'" [status]="'attention'"
      [button]="'settings.merchant.notificationMissingPixType.button'"
      (clickNotification)="seeDetailsPayout()">
    </app-layout-fixed-notifications>
  }
  <!--
 <app-layout-fixed-notifications *ngIf="model.user.realm == 'anota-ai' || model.user.realm == 'delivery-much-brasil'"
    [title]="'settings.merchant.notificationPayoutProblem2.title'" [status]="'attention'"
    [button]="'settings.merchant.notificationPayoutProblem2.button'" (clickNotification)="seeUrlPayout()">
  </app-layout-fixed-notifications> -->

  <mat-sidenav-container class="container" [style.min-height]="'100vh'">
    <mat-sidenav class="menu-mobile" #sidenav [mode]="model.isMobile ? 'over' : 'side'" [opened]="!model.isMobile">
      <div class="matero-sidebar-main scrollbar-none theme-menu-skeleton" #menu fxFlex fxLayout="column" *ngIf="!isLoaded">
        <div class="header-theme-menu-skeleton">
          <div class="big-box"></div>
        </div>
        <div class="buttons-theme-menu-skeleton">
          <div class="button-theme-menu-skeleton"></div>
        </div>
        <div class="list-theme-menu-skeleton">
          <div *ngFor="let item of [1, 2, 3, 4, 5]" class="item-theme-menu-skeleton">
            <div class="list-1-box"></div>
            <div class="list-2-box"></div>
          </div>
        </div>
      </div>

      <div class="matero-sidebar-main scrollbar-none" #menu fxFlex fxLayout="column" *ngIf="isLoaded">
        <div class="logo">
          <a (click)="home()">
            <img class="console-logo" src="/branding/{{ model.partner }}/console/assets/images/logo-{{
                model.theme
              }}.svg" alt="Tuna" />
          </a>
        </div>
        <div fxFlex fxLayout="column" fxLayoutAlign="space-between stretch">
          <div fxFlex [style.paddingBottom.px]="toggleHeight" fxLayout="column" *ngIf="model.user">
            <app-layout-select-partner *ngIf="!model.merchant" (accountChange)="accountChange($event)"
              [user]="model.user" (getNotifications)="getNotifications($event)">
            </app-layout-select-partner>
            <app-layout-select-merchants *ngIf="model.merchant" [user]="model.user"
              (getNotifications)="getNotifications($event)">
            </app-layout-select-merchants>
            <app-layout-menu *ngIf="model.user" (verify)="verify()" [user]="model.user"
              (click)="model.isMobile ? sidenav.toggle() : undefined"></app-layout-menu>
            <div class="h-large" fxFlex="100">
              <app-layout-user-profile (test)="test2($event)"></app-layout-user-profile>
            </div>
          </div>
          <div class="footer-menu" #switchThemeFooter [class.sticky]="sticky">
            <app-layout-change-theme [isDarkTheme]="model.isDarkTheme"
              (changedDarkTheme)="setPreferenceTheme($event)"></app-layout-change-theme>

            <a class="powered-by" [href]="url + '?utm_source=console&utm_medium=menu&utm_campaign=poweredby'" target="_blank">
              <div class="text">🌵 Powered by Tuna</div>
            </a>

            <!-- <a *ngIf="url" class="documentation-btn" [href]="
            url +
            '?utm_source=console&utm_medium=site&utm_campaign=service-settings'
          " target="_blank">{{ "service.edit.documentation" | translate }}
          <mat-icon [svgIcon]="'icon_open_in_new'"></mat-icon></a> -->

          </div>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content *ngIf="!isLoaded">
      <div class="header-skeleton" fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="10">
          <div class="header-skeleton-box">
          </div>
        </div>

        <div fxFlex="255px" fxLayout="row" xLayoutAlign="start center" fxLayoutGap="12px">
          <div class="header-skeleton-button">
          </div>
        </div>
      </div>
    </mat-sidenav-content>

    <mat-sidenav-content *ngIf="isLoaded">
      <div class="header" fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="100%">
          <app-breadcrumb></app-breadcrumb>
        </div>

        <div fxFlex="305px" fxLayout="row" xLayoutAlign="start center" fxLayoutGap="12px">
          <app-search-button></app-search-button>
          <app-notifications-button></app-notifications-button>
          <app-layout-user-profile></app-layout-user-profile>
        </div>
      </div>
      <div class="header-mobile">
        <mat-toolbar>
          <button mat-icon-button fxLayout="row" fxLayoutAlign="center center" (click)="sidenav.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
          <!-- <div class="ml-3">
            <h1>{{ model.title }}</h1>
          </div>
          <span fxFlex></span> -->
          <app-breadcrumb></app-breadcrumb>
        </mat-toolbar>
      </div>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
<div *ngIf="page == 'error'">
  <div class="container" [style.min-height]="'100vh'">
    <app-error></app-error>
  </div>
</div>
<div *ngIf="page == 'not_found'">
  <div class="container" [style.min-height]="'100vh'">
    <app-not-found></app-not-found>
  </div>
</div>
